/**
 * Centralized configuration from environment variables
 * All environment variables should be defined in frontend/.env file
 * 
 * Required environment variable:
 * - REACT_APP_BACKEND_URL: The base URL of the backend API (e.g., http://localhost:8000)
 */

// Backend API URL - read from environment variables
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;

// Validate that BACKEND_URL is set
if (!BACKEND_URL) {
  const errorMsg = `
❌ REACT_APP_BACKEND_URL is not set!

Please create or update frontend/.env file with:
REACT_APP_BACKEND_URL=http://localhost:8000

After creating/updating .env, restart the development server.
`;
  console.error(errorMsg);
  // Show error in browser console and on page
  throw new Error('REACT_APP_BACKEND_URL environment variable is required. Please check your frontend/.env file and restart the dev server.');
}

// API base URL (already includes /api)
export const API = `${BACKEND_URL}/api`;

// WebSocket URL
export const WS_URL = BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');

// Log configuration on load (for debugging)
console.log('🔧 Frontend Configuration (from .env):');
console.log('  BACKEND_URL:', BACKEND_URL);
console.log('  API:', API);
console.log('  WS_URL:', WS_URL);
